import { render, staticRenderFns } from "./openedSubjectDialog.vue?vue&type=template&id=6fb08328&"
import script from "./openedSubjectDialog.vue?vue&type=script&lang=js&"
export * from "./openedSubjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./openedSubjectDialog.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports